import { PLUGIN_URL } from "../../../utils/pluginUrl";
import { V3Button } from "../../Button";
import { UnstyledLink } from "../../ReusableStyledComponents/UnstyledLink";
import { V3BodyGrey35 } from "../../ReusableStyledComponents/V3BodyGrey35";
import { V3CaptionGrey48 } from "../../ReusableStyledComponents/V3CaptionGrey48";
import { V3HeadlineH5 } from "../../Typography";
import { VerticalSpacing } from "../../VerticalSpacing";
import { NoPreviewFoundCTAWrapper, NoPreviewFoundDivider, NoPreviewFoundWrapper } from "./AddContent.styles";

interface NoPreviewFoundPromptProps {
    onPluginCTAClick?: () => void;
}

/**
 * Shown in place of the usual intro paragraph when the metadata lookup came back completely empty,
 * pointing the user at the browser extension before they resort to filling the preview in by hand.
 */
export const NoPreviewFoundPrompt = ({ onPluginCTAClick }: NoPreviewFoundPromptProps) => (
    <>
        <NoPreviewFoundWrapper>
            <VerticalSpacing bottom={6}>
                <V3HeadlineH5>No preview found</V3HeadlineH5>
            </VerticalSpacing>
            <V3BodyGrey35>
                The site may block access, or the page has no preview data. Our extension solves both by capturing the page from your browser.
            </V3BodyGrey35>
            <VerticalSpacing top={16}>
                <NoPreviewFoundCTAWrapper>
                    <UnstyledLink href={PLUGIN_URL} target="_blank" onClick={onPluginCTAClick}>
                        <V3Button type="button" text="Add via browser extension" autoWidth minWidth={240} />
                    </UnstyledLink>
                </NoPreviewFoundCTAWrapper>
            </VerticalSpacing>
        </NoPreviewFoundWrapper>
        <VerticalSpacing top={20}>
            <NoPreviewFoundDivider>
                <V3CaptionGrey48 as="div">or fill it in manually</V3CaptionGrey48>
            </NoPreviewFoundDivider>
        </VerticalSpacing>
    </>
);
